import React, { memo, useState } from 'react';
import { TypeModal } from '@app/modules/errors';
import { isEqual } from 'lodash-es';
import { signify } from 'react-signify';
import PopupDialog, { PopupDialogProps } from './PopupDialog';

type IPop = PopupDialogProps & { refFlag?: object };

const intialDialogInfo: IPop = {
  visible: false,
  position: 'center',
  content: '',
  onNo: () => {
    //
  },
  onYes: () => {
    //
  },
  refFlag: undefined,
  visibleCancelWarning: false,
};

export const dialogSignal = signify<Partial<IPop>>(intialDialogInfo);

const popBuilder = (type: TypeModal) => (content: string | React.ReactNode) => {
  const configClose = () => {
    dialogSignal.set((infoData) => {
      infoData.value.visible = false;
      infoData.value.refFlag = undefined;
    });
  };

  const info: Partial<IPop> = {
    visible: true,
    content,
    type,
    refFlag: {},
    onNo: configClose,
    onYes: configClose,
  };

  dialogSignal.set((infoData) => {
    infoData.value = info;
  });

  const onNo = ({
    callback,
    visibleCancelWarning = false,
  }: {
    callback: () => void;
    visibleCancelWarning?: boolean;
  }) => {
    dialogSignal.set((infoData) => {
      infoData.value.onNo = () => {
        configClose();
        callback();
      };
      infoData.value.visibleCancelWarning = visibleCancelWarning;
    });

    return { onYes };
  };
  const onYes = (callback: () => void) => {
    dialogSignal.set((infoData) => {
      infoData.value.onYes = () => {
        configClose();
        callback();
      };
    });
    return { onNo };
  };

  return {
    onNo,
    onYes,
  };
};

export const DialogPop = () => {
  const [dialogInform, setDialogInform] = useState<IPop>(intialDialogInfo);

  dialogSignal.watch((info) => {
    if (isEqual(dialogInform.refFlag, info.refFlag) || dialogInform.refFlag === undefined) {
      setDialogInform((preState) => ({ ...preState, ...info }));
    }
  });

  // Remove the dialogInform.refFlag property
  const { refFlag, ...popupDialogProps } = dialogInform;

  return <PopupDialog {...popupDialogProps} />;
};

export const pop = {
  normal: popBuilder(TypeModal.NORMAL),
  warning: popBuilder(TypeModal.WARNING),
  error: popBuilder(TypeModal.ERROR),
  info: popBuilder(TypeModal.INFO),
  inquiry: popBuilder(TypeModal.INQUIRY),
};

export default memo(DialogPop, () => true);
